import React, { useState, useEffect, useRef } from 'react';
import { IoClose } from "react-icons/io5";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const CustomDropdown = ({
    id,
    dataList,
    placeholder,
    onItemSelect,
    clearInput,
    labelKey,
    idKey,
    value,
    isOpen,
    onToggle,
    onClose,
    ClearInputDisable,
    ArrowsDisable,
    NewClassName,
    disabled
}) => {
    const [data, setData] = useState(value || '');
    const [filteredList, setFilteredList] = useState(dataList || []);
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const dropdownRef = useRef();
    const focusedItemRef = useRef();

    useEffect(() => {
        setData(value || '');
        setFilteredList(dataList || []);
    }, [value, dataList]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isOpen) return;

            switch (e.key) {
                case 'ArrowDown':
                    setFocusedIndex((prevIndex) =>
                        Math.min(prevIndex + 1, filteredList.length - 1)
                    );
                    break;
                case 'ArrowUp':
                    setFocusedIndex((prevIndex) =>
                        Math.max(prevIndex - 1, 0)
                    );
                    break;
                case 'Enter':
                    if (focusedIndex >= 0) {
                        const selectedItem = filteredList[focusedIndex];
                        handleItemClick(selectedItem[idKey], selectedItem[labelKey]);
                    }
                    break;
                case 'Escape':
                    handleClose();
                    break;
                default:
                    break;
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, filteredList, focusedIndex]);

    useEffect(() => {
        if (focusedItemRef.current) {
            focusedItemRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [focusedIndex]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleItemClick = (id, val) => {
        setData(val);
        onItemSelect(id, val);
        handleClose();
    };

    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        setData(inputValue);
        setFocusedIndex(-1); // Reset focus on input change
        setFilteredList(
            dataList.filter(
                (val) =>
                    val[labelKey] &&
                    val[labelKey].toLowerCase().includes(inputValue.toLowerCase())
            )
        );
        if (!isOpen) onToggle();
    };

    const handleClose = () => {
        onClose();
        setFocusedIndex(-1); // Reset focus when dropdown closes
    };

    return (
        <div
            id={id}
            ref={dropdownRef}
            className="dropdown"
            style={{ position: 'relative', width: '100%', height: '100%' }}
        >
            <input
                type="text"
                value={data}
                onChange={handleInputChange}
                onClick={(e) => {
                    e.stopPropagation();
                    onToggle();
                }}
                placeholder={placeholder}
                className={NewClassName ? NewClassName : "SelectCommonDropdownInput"}
                disabled={disabled}
            />
            {isOpen ? (
                (!ArrowsDisable && <IoIosArrowUp className="SelectCommonDropdownArrowIcon" />)
            ) : (
                (!ArrowsDisable && <IoIosArrowDown className="SelectCommonDropdownArrowIcon" />)
            )}
            {data && !ClearInputDisable && (
                <IoClose
                    onClick={() => {
                        setData('');
                        setFilteredList(dataList);
                        clearInput();
                        handleClose();
                    }}
                    className="SelectCommonDDclearIcon"
                />
            )}
            {isOpen && (
                <div
                    className="SelectCommonDropDownSty"
                    style={{ maxHeight: '200px', overflowY: 'auto' }}
                >
                    {filteredList.length > 0 ? (
                        filteredList.map((item, index) => (
                            <div
                                key={item[idKey]}
                                ref={index === focusedIndex ? focusedItemRef : null}
                                // onClick={() => handleItemClick(item[idKey], item[labelKey])}
                                onMouseDown={(e) => {
                                    e.preventDefault(); // Prevent input blur
                                    handleItemClick(item[idKey], item[labelKey]);
                                }}
                                className={`SelectCommonDropDownList ${index === focusedIndex ? 'focused' : ''
                                    }`}
                                style={{
                                    backgroundColor:
                                        index === focusedIndex ? '#e0e0e0' : 'transparent',
                                }}
                            >
                                {item[labelKey]}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: '10px' }}>No results</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;

